import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { CONFIG } from '../../../api/config'
import ButtonComponent from '../../../components/ui/button.component'
import { ConfirmModalComponent } from '../../../components/ui/modals/confirm.modal.component'
import DecorImage from '../../../styles/icons/banner-decor.png'
import DecorMobileImage from '../../../styles/icons/mobile-decor.png'
import DecorTabletImage from '../../../styles/icons/tablet-decor.png'
import useWindowWidth from '../../../utils/use.window.width'
import * as styled from './styled'

export const BannerComponent = () => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth <= 530
  const isTablet = windowWidth <= 1024

  const decorSrc = isMobile ? DecorMobileImage : isTablet ? DecorTabletImage : DecorImage

  const handleButtonClick = () => {
    const isSkipMode = localStorage.getItem('skipConfirmCabinet') === 'true'

    if (isSkipMode) {
      window.open(CONFIG.SMART_CITY, '_blank', 'noopener,noreferrer')
    } else {
      setIsConfirmOpen(true)
    }
  }

  return (
    <styled.BannerWrapper>
      <styled.BannerContainer>
        <styled.BannerDecor src={decorSrc} />
        <styled.BannerTextBlock>
          <styled.TextBlockHeading>
            Незламного міста <span>Запоріжжя!</span>
          </styled.TextBlockHeading>
          <styled.TextBlockActions>
            <ButtonComponent text='Подати звернення' position='bottom-right' onClick={handleButtonClick}/>
           {/* <ButtonComponent text='Відстежити звернення' position='top-right' /> */}
          </styled.TextBlockActions>
        </styled.BannerTextBlock>
      </styled.BannerContainer>
      <AnimatePresence>
        {isConfirmOpen && (
          <ConfirmModalComponent 
            onClose={() => setIsConfirmOpen(false)} 
            onBack={() => setIsConfirmOpen(false)} 
          />
        )}
      </AnimatePresence>
    </styled.BannerWrapper>
  )
}